import Interpretations from './Interpretations'

export default Interpretations



// WEBPACK FOOTER //
// ./src/legacy/components/Interpretations/index.js